// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { MessageCircle, X } from "lucide-react";

// export default function CareerChatbot() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { from: "bot", text: "👋 Hi! Welcome to Systematic Career Planner. How can I assist you today?" },
//   ]);
//   const [input, setInput] = useState("");

//   const businessNumber = "+91 98765 43210"; // 🔗 Replace with your real contact number

//   const responses = {
//     courses: "📘 We provide guidance on trending IT, Finance, and Management courses.",
//     career: "💡 Career planning depends on your background and interests. I can guide you generally.",
//     job: "🧑‍💼 We help freshers and professionals prepare for job roles through structured planning.",
//     resume: "📄 Yes! We provide tips on making ATS-friendly resumes.",
//     default: `🤝 That's a great question! For a complete and personalized solution, please call our expert at ${businessNumber}. They will assist you properly.`,
//   };

//   const handleSend = () => {
//     if (!input.trim()) return;
//     const newMessage = { from: "user", text: input };
//     setMessages([...messages, newMessage]);

//     const lowerInput = input.toLowerCase();
//     let reply = responses.default;

//     if (lowerInput.includes("course")) reply = responses.courses;
//     else if (lowerInput.includes("career")) reply = responses.career;
//     else if (lowerInput.includes("job")) reply = responses.job;
//     else if (lowerInput.includes("resume")) reply = responses.resume;

//     setTimeout(() => {
//       setMessages((prev) => [...prev, { from: "bot", text: reply }]);
//     }, 600);

//     setInput("");
//   };

//   return (
//     <>
//       {/* Floating Chat Button */}
//       <motion.button
//         className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg"
//         onClick={() => setIsOpen(!isOpen)}
//         whileHover={{ scale: 1.1 }}
//       >
//         {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
//       </motion.button>

//       {/* Chat Window */}
//       {isOpen && (
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="fixed bottom-20 right-6 w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden"
//         >
//           {/* Header */}
//           <div className="bg-blue-600 text-white px-4 py-3 font-semibold">
//             Systematic Career Planner 🤖
//           </div>

//           {/* Messages */}
//           <div className="flex-1 p-3 overflow-y-auto space-y-2">
//             {messages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`p-2 rounded-xl max-w-[80%] ${
//                   msg.from === "bot"
//                     ? "bg-gray-100 text-gray-800 self-start"
//                     : "bg-blue-600 text-white self-end ml-auto"
//                 }`}
//               >
//                 {msg.text}
//               </div>
//             ))}
//           </div>

//           {/* Input Box */}
//           <div className="p-2 border-t flex">
//             <input
//               className="flex-1 border rounded-xl px-3 py-2 text-sm focus:outline-none"
//               placeholder="Type your message..."
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSend()}
//             />
//             <button
//               className="ml-2 bg-blue-600 text-white px-3 py-2 rounded-xl text-sm"
//               onClick={handleSend}
//             >
//               Send
//             </button>
//           </div>
//         </motion.div>
//       )}
//     </>
//   );
// }
// import React, { useState, useRef, useEffect } from "react";
// import { motion } from "framer-motion";
// // import { MessageCircle, X } from "lucide-react";
// import { X } from "lucide-react";
// import CareerBoot1 from '../assets/CareerBot1.png';

// export default function CareerChatbot() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { from: "bot", text: "👋 Hi! I’m your AI Career Assistant. How can I help today?" },
//   ]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);

//   // 🔽 Ref for auto-scroll
//   const messagesEndRef = useRef(null);

//   // 🔽 Scroll to bottom whenever messages change
//   useEffect(() => {
//     if (messagesEndRef.current) {
//       messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
//     }
//   }, [messages, loading]);

//   const handleSend = async () => {
//     if (!input.trim()) return;

//     const newMessage = { from: "user", text: input };
//     setMessages((prev) => [...prev, newMessage]);
//     setInput("");
//     setLoading(true);

//     try {
//       const res = await fetch("http://localhost:5000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: input }),
//       });

//       const data = await res.json();
//       setMessages((prev) => [...prev, { from: "bot", text: data.reply }]);
//     } catch (err) {
//       setMessages((prev) => [
//         ...prev,
//         { from: "bot", text: "⚠️ Network error, please try again." },
//       ]);
//     }

//     setLoading(false);
//   };

//   return (
//     <>
//       {/* Floating Chat Button */}
//       <motion.button
//         className="fixed bottom-6 right-6 bg-indigo-600 border-2 border-white/70 text-white p-2 rounded-full shadow-lg z-50"
//         onClick={() => setIsOpen(!isOpen)}
//         whileHover={{ scale: 1.1 }}
//       >
//         {isOpen ? <X size={24} /> : <img src={CareerBoot1} alt="Chatbot" className="w-12 h-12"/>}
//       </motion.button>

//       {/* Chat Window */}
//       {isOpen && (
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="fixed bottom-20 right-6 w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden z-50 h-[400px]"
//         >
//           {/* Header */}
//           <div className="bg-blue-600 text-white px-4 py-3 font-semibold">
//             Systematic Career Planner 🤖
//           </div>

//           {/* Messages */}
//           <div className="flex-1 p-3 overflow-y-auto space-y-2">
//             {messages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`p-2 rounded-xl max-w-[80%] ${
//                   msg.from === "bot"
//                     ? "bg-gray-100 text-gray-800 self-start"
//                     : "bg-blue-600 text-white self-end ml-auto"
//                 }`}
//               >
//                 {msg.text}
//               </div>
//             ))}

//             {loading && (
//               <div className="p-2 bg-gray-100 text-gray-600 rounded-xl max-w-[60%]">
//                 ⏳ Thinking...
//               </div>
//             )}

//             {/* 🔽 Dummy div for auto-scroll */}
//             <div ref={messagesEndRef} />
//           </div>

//           {/* Input */}
//           <div className="p-2 border-t flex">
//             <input
//               className="flex-1 border rounded-xl px-3 py-2 text-sm focus:outline-none"
//               placeholder="Type your question..."
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSend()}
//             />
//             <button
//               className="ml-2 bg-blue-600 text-white px-3 py-2 rounded-xl text-sm"
//               onClick={handleSend}
//             >
//               Send
//             </button>
//           </div>
//         </motion.div>
//       )}
//     </>
//   );
// }
// import React, { useState, useRef, useEffect } from "react";
// import { motion } from "framer-motion";
// import { X } from "lucide-react";
// import CareerBoot1 from "../assets/CareerBot1.png";

// export default function CareerChatbot() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([
//     { from: "bot", text: "👋 Hi! I’m your AI Career Assistant. How can I help today?" },
//   ]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);
//   const messagesEndRef = useRef(null);

//   // Auto-scroll
//   useEffect(() => {
//     if (messagesEndRef.current) {
//       messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
//     }
//   }, [messages, loading]);

//   const handleSend = async () => {
//     if (!input.trim()) return;

//     const newMessage = { from: "user", text: input };
//     setMessages((prev) => [...prev, newMessage]);
//     setInput("");
//     setLoading(true);

//     try {
//       const res = await fetch("http://localhost:5000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: input }),
//         credentials: "include", // ✅ important for session
//       });

//       const data = await res.json();
//       setMessages((prev) => [...prev, { from: "bot", text: data.reply }]);

//       // ✅ Handle CTA
//       if (data.cta === "roadmap") {
//         setMessages((prev) => [
//           ...prev,
//           {
//             from: "bot",
//             type: "roadmap", // 🔽 new type to render button
//             text: "🚀 Let’s build your career roadmap!",
//           },
//         ]);
//       }

//       if (data.cta === "call") {
//         setMessages((prev) => [
//           ...prev,
//           { from: "bot", text: "📞 I’d love to guide you further. Call us at +91 98765 43210." },
//         ]);
//       }
//     // } catch {
//     //   setMessages((prev) => [...prev, { from: "bot", text: "⚠️ Network error, please try again." }]);
//     // }
//       } catch (err) {
//         console.error("Frontend Fetch Error:", err);
//         setMessages((prev) => [
//           ...prev,
//           { from: "bot", text: "⚠️ Network error, please try again." },
//         ]);
//       }
//     setLoading(false);
//   };

//   return (
//     <>
//       {/* Floating Button */}
//       <motion.button
//         className="fixed bottom-6 right-6 bg-indigo-600 border-2 border-white/70 text-white p-2 rounded-full shadow-lg z-50"
//         onClick={() => setIsOpen(!isOpen)}
//         whileHover={{ scale: 1.1 }}
//       >
//         {isOpen ? <X size={24} /> : <img src={CareerBoot1} alt="Chatbot" className="w-12 h-12" />}
//       </motion.button>

//       {/* Chat Window */}
//       {isOpen && (
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="fixed bottom-20 right-6 w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden z-50 h-[400px]"
//         >
//           {/* Header */}
//           <div className="bg-blue-600 text-white px-4 py-3 font-semibold">
//             Systematic Career Planner 🤖
//           </div>

//           {/* Messages */}
//           <div className="flex-1 p-3 overflow-y-auto space-y-2">
//             {/* {messages.map((msg, i) => (
//               <div
//                 key={i}
//                 className={`p-2 rounded-xl max-w-[80%] ${
//                   msg.from === "bot"
//                     ? "bg-gray-100 text-gray-800 self-start"
//                     : "bg-blue-600 text-white self-end ml-auto"
//                 }`}
//               >
//                 {msg.text}
//               </div>
//             ))} */}
//             {messages.map((msg, i) => (
//   <div key={i} className="max-w-[80%]">
//     {msg.type === "roadmap" ? (
//       <div className="flex flex-col space-y-2">
//         <div className="p-2 bg-gray-100 text-gray-800 rounded-xl">
//           {msg.text}
//         </div>
//         <button
//           className="bg-green-600 text-white px-3 py-2 rounded-xl text-sm hover:bg-green-700 transition"
//           onClick={() => {
//             document.getElementById("roadmap")?.scrollIntoView({ behavior: "smooth" });
//             setIsOpen(false); // close chat after redirect
//           }}
//         >
//           View My Roadmap
//         </button>
//       </div>
//     ) : (
//       <div
//         className={`p-2 rounded-xl ${
//           msg.from === "bot"
//             ? "bg-gray-100 text-gray-800 self-start"
//             : "bg-blue-600 text-white self-end ml-auto"
//         }`}
//       >
//         {msg.text}
//       </div>
//     )}
//   </div>
// ))}

//             {loading && <div className="p-2 bg-gray-100 text-gray-600 rounded-xl">⏳ Thinking...</div>}
//             <div ref={messagesEndRef} />
//           </div>

//           {/* Input */}
//           <div className="p-2 border-t flex">
//             <input
//               className="flex-1 border rounded-xl px-3 py-2 text-sm focus:outline-none"
//               placeholder="Type your question..."
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSend()}
//             />
//             <button
//               className="ml-2 bg-blue-600 text-white px-3 py-2 rounded-xl text-sm"
//               onClick={handleSend}
//             >
//               Send
//             </button>
//           </div>
//         </motion.div>
//       )}
//     </>
//   );
// }
import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import CareerBoot1 from "../assets/CareerBot1.png";

export default function CareerChatbot({ isOpen, setIsOpen, onRoadmapClick }) {  // ✅ accept prop
  // if (!isOpen) return null;
  // const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: "bot", text: "👋 Hi! I’m your AI Career Assistant. How can I help today?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  // Auto-scroll
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, loading]);

//   const handleSend = async () => {
//     if (!input.trim()) return;

//     const newMessage = { from: "user", text: input };
//     setMessages((prev) => [...prev, newMessage]);
//     setInput("");
//     setLoading(true);

//     try {
//       const res = await fetch("http://localhost:5000/chat", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ message: input }),
//         credentials: "include", // ✅ important for session
//       });

//       const data = await res.json();
//       setMessages((prev) => [...prev, { from: "bot", text: data.reply }]);

//       // ✅ Handle CTA
//       // if (data.cta === "roadmap") {
//       //   setMessages((prev) => [
//       //     ...prev,
//       //     {
//       //       from: "bot",
//       //       type: "roadmap",
//       //       text: "🚀 Let’s build your career roadmap!",
//       //     },
//       //   ]);
//       // }
//           if (data.cta === "roadmap" && data.data) {
//   onRoadmapClick(data.data); // 🔥 send session data to App.js
//   setMessages((prev) => [
//     ...prev,
//     { from: "bot", type: "roadmap", text: "🚀 Let’s build your career roadmap!" },
//   ]);
// } else {
//   setMessages((prev) => [...prev, { from: "bot", text: data.reply }]);
// }

//       if (data.cta === "call") {
//         setMessages((prev) => [
//           ...prev,
//           { from: "bot", text: "📞 I’d love to guide you further. Call us at +91 98765 43210." },
//         ]);
//       }
//     } catch (err) {
//       console.error("Frontend Fetch Error:", err);
//       setMessages((prev) => [
//         ...prev,
//         { from: "bot", text: "⚠️ Network error, please try again." },
//       ]);
//     }
//     setLoading(false);
//   };
      const handleSend = async () => {
  if (!input.trim()) return;

  const newMessage = { from: "user", text: input };
  setMessages((prev) => [...prev, newMessage]);
  setInput("");
  setLoading(true);

  try {
    const res = await fetch("http://localhost:5000/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: input }),
      credentials: "include",
    });

    const data = await res.json();

    // ✅ Always add the main reply first
    console.log("Backend response:", data);
    let newMessages = [{ from: "bot", text: data.reply }];

    // ✅ If roadmap CTA + data exists, send to App + show CTA button
    if (data.cta === "roadmap" && data.data) {
      onRoadmapClick(data.data);
      newMessages.push({
        from: "bot",
        type: "roadmap",
        text: "🚀 Let’s build your career roadmap!",
      });
    }

    if (data.cta === "call") {
      newMessages.push({
        from: "bot",
        type: "call",
        text: "📞 I’d love to guide you further. Call us at +91 98765 43210.",
      });
    }

    // ✅ Update messages in one go
    setMessages((prev) => [...prev, ...newMessages]);

  } catch (err) {
    console.error("Frontend Fetch Error:", err);
    setMessages((prev) => [
      ...prev,
      { from: "bot", text: "⚠️ Network error, please try again." },
    ]);
  }
  setLoading(false);
};

  return (
    <>
      {/* Unified Floating Pill Container */}
      <div className="fixed bottom-6 right-6 z-50 flex items-stretch bg-white/40 backdrop-blur-md rounded-3xl shadow-2xl border border-gray-400 overflow-hidden">
        {/* WhatsApp Button */}
        <a
          href="https://wa.me/919920405421?text=Hello!%20I'm%20interested%20in%20career%20guidance%20from%20Systematic%20Career%20Planner."
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-1 px-4 py-2 hover:bg-green-50 transition-colors duration-200"
          aria-label="Chat on WhatsApp"
          title="Chat on WhatsApp"
        >
          <span className="flex items-center justify-center w-10 h-10 bg-green-500 rounded-full text-white">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-6 h-6 fill-current">
              <path d="M16.004 0C7.165 0 .003 7.161.003 15.999c0 2.819.737 5.571 2.139 7.998L.005 32l8.186-2.147A15.94 15.94 0 0 0 16.004 32C24.838 32 32 24.837 32 15.999 32 7.161 24.838 0 16.004 0zm0 29.393a13.36 13.36 0 0 1-6.817-1.864l-.489-.29-5.064 1.33 1.352-4.937-.317-.505A13.32 13.32 0 0 1 2.61 15.999c0-7.39 6.01-13.399 13.394-13.399 7.39 0 13.396 6.01 13.396 13.399 0 7.391-6.006 13.394-13.396 13.394zm7.346-10.034c-.402-.201-2.379-1.174-2.748-1.308-.369-.134-.638-.201-.907.201-.268.402-1.041 1.308-1.276 1.576-.235.268-.469.302-.871.101-.402-.201-1.699-.626-3.235-1.997-1.196-1.068-2.003-2.387-2.238-2.789-.235-.402-.025-.619.177-.82.181-.18.402-.469.604-.704.201-.235.268-.402.402-.67.134-.268.067-.503-.034-.704-.101-.201-.907-2.186-1.242-2.993-.327-.786-.659-.68-.907-.693l-.772-.013c-.268 0-.704.101-1.073.503s-1.408 1.375-1.408 3.354c0 1.979 1.441 3.891 1.642 4.159.201.268 2.836 4.331 6.874 6.074.961.415 1.711.662 2.295.848.965.306 1.843.263 2.537.16.774-.116 2.379-.973 2.715-1.912.335-.939.335-1.744.235-1.912-.101-.168-.369-.268-.772-.469z" />
            </svg>
          </span>
          <span className="text-[10px] font-semibold text-green-700">WhatsApp</span>
        </a>

        {/* Divider Line */}
        <div className="w-px bg-gray-300 my-2"></div>

        {/* Chatbot Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex flex-col items-center justify-center gap-1 px-5 py-2 hover:bg-indigo-50 transition-colors duration-200"
          title="Career Assistant"
        >
          <span className="flex items-center justify-center w-10 h-10 bg-indigo-600 rounded-full text-white">
            {isOpen ? <X size={20} /> : <img src={CareerBoot1} alt="Chatbot" className="w-8 h-8" />}
          </span>
          <span className="text-[10px] font-semibold text-indigo-700">Chat Bot</span>
        </button>
      </div>

      {/* Chat Window */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          className="fixed bottom-[100px] right-6 w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden z-50 h-[400px]"
        >
          {/* Header */}
          <div className="bg-blue-600 text-white px-4 py-3 font-semibold">
            Systematic Career Planner 🤖
          </div>

          {/* Messages */}
          <div className="flex-1 p-3 overflow-y-auto space-y-2">
            {messages.map((msg, i) => (
              <div key={i} className={`flex ${msg.from === "user" ? "justify-end" : "justify-start"}`}>
                {msg.type === "roadmap" ? (
                  <div className="flex flex-col space-y-2">
                    <div className="p-2 bg-gray-100 text-gray-800 rounded-xl">
                      {msg.text}
                    </div>
                    <button
                      className="bg-green-600 text-white px-3 py-2 rounded-xl text-sm hover:bg-green-700 transition"
                      onClick={() => {
                        // ✅ Inject mock data for now (later can fetch dynamic)
                        const profile = {
                          stage: "Graduate",
                          goal: "Skill Development",
                          interest: "Technology",
                        };
                        onRoadmapClick(profile); // ✅ update App state
                        document.getElementById("roadmap")?.scrollIntoView({ behavior: "smooth" });
                        setIsOpen(false);
                      }}
                    >
                      View My Roadmap
                    </button>
                  </div>
                ) : (
                  <div
                    className={`p-2 rounded-xl ${
                      msg.from === "bot"
                        ? "bg-gray-100 text-gray-800 self-start rounded-2xl rounded-tl-sm"
                        : "bg-blue-600 text-white self-end rounded-2xl rounded-tr-sm"
                    }`}
                  >
                    {msg.text}
                  </div>
                )}
              </div>
            ))}

            {loading && <div className="p-2 bg-gray-100 text-gray-600 rounded-xl">⏳ Thinking...</div>}
            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <div className="p-2 border-t flex">
            <input
              className="flex-1 border rounded-xl px-3 py-2 text-sm focus:outline-none"
              placeholder="Type your question..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
            />
            <button
              className="ml-2 bg-blue-600 text-white px-3 py-2 rounded-xl text-sm"
              onClick={handleSend}
            >
              Send
            </button>
          </div>
        </motion.div>
      )}
    </>
  );
}
